import TryoutGroup from "@/modules/tryout_group/components/TryoutGroup";
import TryoutGroupForm from "@/modules/tryout_group/components/Form";

export default [
    {
        path: "/tryout-groups",
        name: "TryoutGroup",
        component: TryoutGroup,
    },
    {
        path: "/tryout-group/form",
        name: "TryoutGroupForm",
        component: TryoutGroupForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/tryout_group/router/tryout_group.js